import { c as _c } from "react/compiler-runtime";
import React, { useState } from 'react';
import { Button, Modal, Alert, List, Loader, Checkbox, Switch, Tooltip } from '@mantine/core';
import { useForm } from '@mantine/form';
import { HiUpload } from 'react-icons/hi';
import { usePortal } from 'components/portal/portal';
import { Publish } from 'api/publish';
import { Dropzone, MIME_TYPES } from '@mantine/dropzone';
import { BsClipboardCheckFill, BsClipboardPlusFill, BsClipboardXFill } from 'react-icons/bs';
import { IconContext } from 'react-icons';
import { openExport } from './export';
import { useMutation } from '@tanstack/react-query';
import { isNullOrEmpty, notNullOrEmpty } from 'shared/collection';
import { partition } from 'remeda';
import { okOrThrow } from 'shared/promise';
import { Markdown, WrapIf } from 'shared/ui';
export const QuestionImport = t0 => {
  const $ = _c(54);
  const {
    onImportComplete,
    children
  } = t0;
  const {
    workspace_id
  } = usePortal();
  const [opened, setOpened] = useState(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [selectedIds, setSelectedIds] = useState(t1);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      initialValues: {
        includeForecasts: true,
        includeComments: true,
        anonymizeUsers: false
      }
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const form = useForm(t2);
  const close = () => {
    setOpened(false);
    setSelectedIds([]);
    form.reset();
    openFileMutation.reset();
    importMutation.reset();
  };
  let t3;
  if ($[2] !== form) {
    t3 = {
      mutationFn: _temp2,
      onSuccess: t4 => {
        const {
          questions: questions_0,
          hasProfiles: hasProfiles_0,
          hasForecasts: hasForecasts_0,
          hasComments: hasComments_0
        } = t4;
        setSelectedIds(questions_0.map(_temp3));
        const values = {
          anonymizeUsers: !hasProfiles_0,
          includeForecasts: hasForecasts_0,
          includeComments: hasComments_0
        };
        console.log("values", values);
        form.setValues(values);
      }
    };
    $[2] = form;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const openFileMutation = useMutation(t3);
  const importMutation = useMutation({
    mutationFn: t4 => {
      const {
        file: file_0,
        questionIds
      } = t4;
      openFileMutation.data?.hasProfiles ?? false;
      return Publish.importQuestion({
        file: file_0,
        questionIds,
        workspace_id,
        ...form.values
      }).then(okOrThrow);
    },
    onSuccess: result => {
      close();
      onImportComplete?.(result);
    }
  });
  const selectedCount = selectedIds.length;
  let t5;
  if ($[4] !== openFileMutation.data) {
    t5 = openFileMutation.data?.questions ?? [];
    $[4] = openFileMutation.data;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const questions_1 = t5;
  let t6;
  let t7;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <HiUpload />;
    t7 = () => setOpened(true);
    $[6] = t6;
    $[7] = t7;
  } else {
    t6 = $[6];
    t7 = $[7];
  }
  const t8 = children ?? "Import";
  let t9;
  if ($[8] !== t8) {
    t9 = <Button variant="subtle" leftSection={t6} onClick={t7}>{t8}</Button>;
    $[8] = t8;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  let t11;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = {
      body: "max-h-[80vh] flex flex-col gap-2"
    };
    t11 = <div className="opacity-60">Upload a swift export file to import questions into this workspace</div>;
    $[10] = t10;
    $[11] = t11;
  } else {
    t10 = $[10];
    t11 = $[11];
  }
  let t12;
  if ($[12] !== openFileMutation.error) {
    t12 = openFileMutation.error && <Alert title="Error reading the import file" color="red">{openFileMutation.error.message}</Alert>;
    $[12] = openFileMutation.error;
    $[13] = t12;
  } else {
    t12 = $[13];
  }
  let t13;
  if ($[14] !== form || $[15] !== openFileMutation || $[16] !== questions_1 || $[17] !== selectedCount || $[18] !== selectedIds) {
    t13 = questions_1.length === 0 ? <Dropzone loading={openFileMutation.isPending} onDrop={async files => {
      setSelectedIds([]);
      form.reset();
      openFileMutation.mutate(files[0] as File);
    }} accept={[MIME_TYPES.zip, "application/x-zip-compressed"]} color="gray.5" classNames={{
      root: "flex justify-center items-center w-full p-2 !rounded-lg",
      inner: "pointer-events-none flex items-center gap-4"
    }}><IconContext.Provider value={{
        size: "3em"
      }}><Dropzone.Accept><BsClipboardCheckFill style={{
            color: "var(--mantine-color-primary-filled)"
          }} /></Dropzone.Accept><Dropzone.Reject><BsClipboardXFill style={{
            color: "var(--mantine-color-red-7)"
          }} /></Dropzone.Reject><Dropzone.Idle><BsClipboardPlusFill style={{
            color: "var(--mantine-color-dimmed)",
            opacity: 0.2
          }} /></Dropzone.Idle></IconContext.Provider><div className="text-gray-500/50 font-bold">{openFileMutation.isPending ? "Reading file..." : "Drag question exports here (*.swift.zip) to import questions into this workspace, or click to open"}</div></Dropzone> : <div className="flex flex-col min-h-0 flex-1"><div className="flex items-center gap-2 mb-3"><Button variant="outline" size="xs" onClick={() => setSelectedIds([])} disabled={selectedCount === 0}>Deselect all</Button><Button variant="outline" size="xs" onClick={() => setSelectedIds(questions_1.map(_temp4))} disabled={selectedCount === questions_1.length}>Select all</Button></div><div className="overflow-y-auto -mx-4 px-4 flex-1">{questions_1.map(question => <Checkbox key={question.id} label={<div className="font-semibold">{question.title}</div>} checked={selectedIds.includes(question.id)} onChange={() => setSelectedIds(prev => prev.includes(question.id) ? prev.filter(qId => qId !== question.id) : [...prev, question.id])} className="mb-2" />)}</div></div>;
    $[14] = form;
    $[15] = openFileMutation;
    $[16] = questions_1;
    $[17] = selectedCount;
    $[18] = selectedIds;
    $[19] = t13;
  } else {
    t13 = $[19];
  }
  let t14;
  if ($[20] !== form || $[21] !== openFileMutation.data || $[22] !== questions_1.length) {
    t14 = questions_1.length > 0 && <div className="space-y-3 border-t pt-4"><div className="font-semibold text-sm">Import Options</div><WrapIf if={!openFileMutation.data?.hasForecasts} wrap={_temp5}><Switch label="Import forecasts" description="Include all forecasts when importing questions" disabled={!openFileMutation.data?.hasForecasts} {...form.getInputProps("includeForecasts", {
          type: "checkbox"
        })} /></WrapIf><WrapIf if={!openFileMutation.data?.hasProfiles} wrap={_temp6}><Switch label="Import comments" description="Include all comments and discussions when importing questions" disabled={!openFileMutation.data?.hasComments} {...form.getInputProps("includeComments", {
          type: "checkbox"
        })} /></WrapIf><WrapIf if={!openFileMutation.data?.hasProfiles} wrap={_temp7}><Switch label="Anonymise users" description="Replace user profiles with anonymous IDs. User names and avatars will be removed" disabled={!openFileMutation.data?.hasProfiles} {...form.getInputProps("anonymizeUsers", {
          type: "checkbox"
        })} /></WrapIf></div>;
    $[20] = form;
    $[21] = openFileMutation.data;
    $[22] = questions_1.length;
    $[23] = t14;
  } else {
    t14 = $[23];
  }
  let t15;
  if ($[24] !== importMutation.error) {
    t15 = importMutation.error && <Alert title="Import Error" color="red" className="flex-shrink-0"><Markdown>{importMutation.error.message}</Markdown></Alert>;
    $[24] = importMutation.error;
    $[25] = t15;
  } else {
    t15 = $[25];
  }
  let t16;
  if ($[26] !== close || $[27] !== importMutation.isPending) {
    t16 = <Button variant="subtle" onClick={close} disabled={importMutation.isPending}>Cancel</Button>;
    $[26] = close;
    $[27] = importMutation.isPending;
    $[28] = t16;
  } else {
    t16 = $[28];
  }
  let t17;
  if ($[29] !== importMutation || $[30] !== openFileMutation.data || $[31] !== selectedIds) {
    t17 = () => {
      if (selectedIds.length === 0 || !openFileMutation.data?.file) {
        return;
      }
      importMutation.mutate({
        file: openFileMutation.data.file,
        questionIds: selectedIds
      });
    };
    $[29] = importMutation;
    $[30] = openFileMutation.data;
    $[31] = selectedIds;
    $[32] = t17;
  } else {
    t17 = $[32];
  }
  const t18 = !openFileMutation.data?.file || selectedCount === 0;
  let t19;
  if ($[33] !== importMutation.isPending) {
    t19 = importMutation.isPending ? <Loader size="xs" /> : undefined;
    $[33] = importMutation.isPending;
    $[34] = t19;
  } else {
    t19 = $[34];
  }
  const t20 = importMutation.isPending ? "Importing..." : `Import ${selectedCount} Questions`;
  let t21;
  if ($[35] !== t17 || $[36] !== t18 || $[37] !== t19 || $[38] !== t20) {
    t21 = <Button variant="filled" onClick={t17} disabled={t18} leftSection={t19}>{t20}</Button>;
    $[35] = t17;
    $[36] = t18;
    $[37] = t19;
    $[38] = t20;
    $[39] = t21;
  } else {
    t21 = $[39];
  }
  let t22;
  if ($[40] !== t16 || $[41] !== t21) {
    t22 = <div className="flex justify-end gap-2">{t16}{t21}</div>;
    $[40] = t16;
    $[41] = t21;
    $[42] = t22;
  } else {
    t22 = $[42];
  }
  let t23;
  if ($[43] !== close || $[44] !== opened || $[45] !== t12 || $[46] !== t13 || $[47] !== t14 || $[48] !== t15 || $[49] !== t22) {
    t23 = <Modal opened={opened} onClose={close} title="Import Questions" size="lg" classNames={t10}>{t11}{t12}{t13}{t14}{t15}{t22}</Modal>;
    $[43] = close;
    $[44] = opened;
    $[45] = t12;
    $[46] = t13;
    $[47] = t14;
    $[48] = t15;
    $[49] = t22;
    $[50] = t23;
  } else {
    t23 = $[50];
  }
  let t24;
  if ($[51] !== t23 || $[52] !== t9) {
    t24 = <>{t9}{t23}</>;
    $[51] = t23;
    $[52] = t9;
    $[53] = t24;
  } else {
    t24 = $[53];
  }
  return t24;
};
function _temp(q) {
  return {
    id: q.id,
    title: q.cfg.title
  };
}
async function _temp2(file) {
  const exportFile = await openExport(file);
  const questionsData = await exportFile.getQuestions();
  if (!questionsData.ok) {
    throw new Error(`Error reading questions from the file: ${questionsData.message}`);
  }
  const {
    questions,
    hasForecasts,
    hasComments
  } = questionsData;
  if (isNullOrEmpty(questions)) {
    throw new Error("No questions found in the file");
  }
  const hasProfiles = await exportFile.hasProfiles();
  return {
    questions: questions.map(_temp),
    file,
    hasProfiles,
    hasForecasts,
    hasComments
  };
}
function _temp3(q_0) {
  return q_0.id;
}
function _temp4(q_1) {
  return q_1.id;
}
function _temp5(c) {
  return <Tooltip label="This export does not contain forecasts"><div>{c}</div></Tooltip>;
}
function _temp6(c_0) {
  return <Tooltip label="This export does not contain comments"><div>{c_0}</div></Tooltip>;
}
function _temp7(c_1) {
  return <Tooltip label="This export is anonymized already"><div>{c_1}</div></Tooltip>;
}